var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.filters)?_c('GenericExplorer',{attrs:{"filters":_vm.filters,"views":_vm.available_views(_vm.is_mobile,_vm.views_props),"is_mobile":_vm.is_mobile,"title":_vm.title,"hide_add_button":""},on:{"update":_vm.update_filters}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }